import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'report.qualifications.title',
    description: 'Title for reports qualifications info section',
    defaultMessage: 'Pätevyydet',
  },

  qualificationsTitle: {
    id: 'report.qualifications.qualifications.title',
    description: 'Subtitle for reports qualifications info section company qualifications',
    defaultMessage: 'Yrityspätevyydet',
  },

  competenceTitle: {
    id: 'report.qualifications.competence.title',
    description: 'Subtitle for reports qualifications info section person competences',
    defaultMessage: 'Henkilöpätevyyksien lukumäärä (Tuotu Taitorekisteri-palvelusta)',
  },

  competencePerson: {
    id: 'report.qualifications.competence.person',
    description: 'Person label for the amount of personal competences in the company',
    defaultMessage: 'hlö',
  },

  competenceInfo: {
    id: 'report.qualifications.competence.info',
    description: 'Info about competence sources.',
    defaultMessage: 'Luottoluokitukset näytetään vain niistä yrityksistä, jotka ovat ostaneet luottoluokituksen näkyvyviin maksullisena lisäpalveluna.',
  },

  qualificationInfo: {
    id: 'report.qualifications.qualifications.info',
    description: 'Info about qualification sources.',
    defaultMessage: 'Palvelussa näytetään vain valikoitujen Vastuu Groupin partereiden hallinnoimat yrityspätevyydet.',
  },
});
